<template>
  <div class="Comment">
    <div class="pages">
      <div class="card-head">
        <div class="left">
          <img :src="res.img" alt />
        </div>
        <div class="right">
          <p class="text">{{res.title}}</p>
          <div>
            总价：
            <span class="orgin">￥{{res.price|priceFilter}}</span>
          </div>
          <!-- <div class="right-bottom">
            <van-button @click="handleRebate">取消退款</van-button>
          </div>-->
        </div>
      </div>
      <div class="make-group">
        <p>
          还差
          <span class="blue">{{this.num}}</span>人拼团成功，快邀请好友一起拼单吧～
        </p>
        <div class="head-list">
          <van-image
            v-for="(v,index) in theItem.userOrderList"
            :key="index"
            round
            width="50"
            :src="v.headimgurl"
          ></van-image>
          <van-image
            round
            v-for="v in num"
            :key="v"
            width="50"
            :src="require('@/assets/images/temp/n-head.png')"
          ></van-image>
          <!-- <van-image round width="50" :src="require('@/assets/images/temp/n-head.png')"></van-image> -->
        </div>
        <div class="tab-button">
          <van-button type="primary" @click="goTuan">邀请好友</van-button>
          <!-- <van-button type="default" @click="handleRebate">申请退款</van-button> -->
        </div>
      </div>
    </div>
    <div class="pad-border pages">
      <!-- 订单信息 -->
      <div class="in-title">
        <i></i>
        <span>订单信息</span>
      </div>
      <ul class="orders">
        <li>
          <span class="label">数量:</span>
          <span class="text">{{res.userCardList?res.userCardList.length:0}}</span>
        </li>
        <li>
          <span class="label">下单时间:</span>
          <span class="text">{{res.gmtCreate}}</span>
        </li>
        <li>
          <span class="label">订单编号:</span>
          <span class="text">{{res.orderNo}}</span>
        </li>
      </ul>
    </div>
    <!-- 交易信息 -->
    <div class="card pages">
      <div class="in-title">
        <i></i>
        <span>交易信息</span>
      </div>
      <ul class="orders">
        <li>
          <span class="label">交易时间:</span>
          <span class="text">{{res.payTime}}</span>
        </li>
        <li>
          <span class="label">交易编号:</span>
          <span class="text">{{res.transactionId}}</span>
        </li>
        <li>
          <span class="label">支付方式:</span>
          <span class="text">微信支付</span>
        </li>
      </ul>
      <!-- <van-button type="primary" class="large-button" @click="getSubmit">退款详情</van-button> -->
    </div>
    <!-- <GuideInvite :showpreview.sync="bShowGuide" /> -->
  </div>
</template>

<script>
// import GuideInvite from "@/components/guideInvite";
export default {
  name: "Comment",
  // components: { GuideInvite },
  data () {
    return {
      res: {},
      theItem: {},
      len: '',
      num: '',
      bShowGuide: false // 弹窗
    };
  },
  computed: {},
  mounted () {
    this.query = this.getQuery(this);
    this.getDetailRight();
  },
  methods: {
    goTuan () {
      this.go(`/Activity/Tuan?id=${this.res.activityId}&tuanId=${this.res.userOrderTuanId}&showHelp=true`);
    },
    // 退款
    handleRebate () {
      if (this.res.isAppointment === 1) {
        this.$error("活动预约中，无法退款呢");
        return;
      }
      this.go(`/refund?id=${this.query.id}`);
    },
    // /user/userOrder/getOrderInfo
    async getDetailRight () {
      let res = await this.request("/user/userOrder/getOrderInfo", {
        id: this.query.id
      });
      if (res.code === 0) {
        console.log(res);
        this.res = { ...res.data };
        this.getJoinTeam();
      } else {
        this.$error(res.msg);
      }
    },
    async getJoinTeam () {
      try {
        this.loading = true;
        let result = await this.$store.dispatch("postData", {
          url: "/activity/activity/getTeamInfo",
          data: {
            id: this.res.userOrderTuanId
          }
        });
        // console.log(this.dataCheckList);
        // let reg = /-/g;
        this.theItem = {
          ...result.data
          // ptExpireTime: result.data.ptExpireTime.replace(reg, '/')
        };
        if (this.theItem.userOrderList) {
          this.num = this.theItem.ctUserNum - this.theItem.userOrderList.length;
          this.len = this.theItem.userOrderList.length;
        } else {
          this.num = this.theItem.ctUserNum;
        }
        console.log('theItem', this.theItem, this.num, this.len);
      } catch (e) {
        this.$error(e.message);
      }
    },
    // // 取消退款
    // handleRebate () {
    //   this.$dialog
    //     .confirm({
    //       message: "确定取消退款吗？",
    //       messageAlign: "center"
    //     })
    //     .then(() => {
    //       console.log("sure");
    //       if (this.res.isAppointment === 1) {
    //         this.$error("活动预约中，无法退款呢");
    //         return;
    //       }
    //       this.go(`/refund?id=${this.query.id}`);
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // },
    // 评价
    getSubmit () {
      this.go("/backMoneyDetail");
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.Comment {
  background: #fff;
  height: 100vh;
  overflow: auto;
  .pages {
    background: #fff;
    padding: @pad;
    &.last-page {
      margin-bottom: 0;
    }
  }
  .grey {
    color: #585858;
  }
  .orange {
    color: #ff8939;
  }
  .blue {
    color: @baseColor;
  }
  .ellis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #333;
  }
  .in-title {
    .flex-center();
    justify-content: flex-start;
    i {
      display: inline-block;
      width: 3px;
      height: 12px;
      background: #3296fa;
      margin-right: 5px;
    }
    span {
      font-size: 15px;
      font-weight: bold;
      color: #333;
    }
  }
  .pad-border {
    border-top: 10px solid #f7f7f7;
    border-bottom: 10px solid #f7f7f7;
  }
  .card-head {
    .flex-center();
    margin-bottom: @pad;
    .left {
      width: 80px;
      margin-right: @pad;
      img {
        width: 100%;
        border-radius: 3px;
      }
    }
    .right {
      width: 100%;
      .text {
        font-size: 14px;
      }
      .orgin {
        color: #ff8939;
      }
      .right-bottom {
        .flex-center();
        justify-content: flex-end;
        font-size: 13px;
      }
      .van-button {
        padding: 0;
        height: 28px;
        line-height: 28px;
        width: 65px;
        color: #585858;
      }
    }
  }
  .make-group {
    font-size: 14px;
    p {
      line-height: 40px;
      .sc(14px, #585858);
    }
    .head-list {
      .flex-center();
      justify-content: flex-start;
      padding: @pad 0;
      .van-image {
        margin-right: 10px;
      }
    }
    .tab-button {
      .van-button {
        height: 35px;
        line-height: 35px;
        margin-right: @pad;
      }
    }
  }
  .large-button {
    width: 80%;
    display: block;
    // .cl();
    // bottom: 20px;
    margin: 20px auto;
  }
  .orders {
    margin-top: 10px;
    li {
      .label {
        width: 80px;
        display: inline-block;
      }
      line-height: 35px;
      .sc(14px, #979797);
    }
  }
}
</style>